import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/courseTransaction/importer/courseTransactionImporterActions'

export default importerReducers(actions)
